import type { LinkedinParserRelease } from '@hygge/shared';
import { api } from './api';

export async function getLatestLinkedinParserRelease(): Promise<LinkedinParserRelease | null> {
  const { data } = await api.get<LinkedinParserRelease | null>(
    '/extensions/linkedin-parser/releases/latest',
  );
  return data;
}
